const DarkLoader = () => {
  return (
    <>
      <span class="darkLoader"></span>
    </>
  );
};

export default DarkLoader;
